/*
//-------------------------------------------------------
//   Copyright (c) 2024 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     DataFormDataTypes
//   Details:    DataFormDataTypes constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// WI3713 25/01/24 JC       Added
//-------------------------------------------------------
*/
//in line with TCMS INXGlobals.DataFormDataTypeEnum, but only containing relevant data form types
export const dataFormDataTypes = {
	none: 0,
	text: 1,
	check_box: 2,
	date_and_time: 4,
	list: 5,
	numeric_0dp: 6,
	numeric_1dp: 7,
	numeric_2dp: 8,
	numeric_3dp: 9,
	numeric_4dp: 10,
	image: 11,
	signature_box: 13,
	multiline_text: 15,
	section_heading: 17,
	url: 24
};
